// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__fYnnB","defaultH1":"Detail_defaultH1__Coimf"};